import React from 'react';
import { observer } from 'mobx-react';

import File from 'ui/Feed/File';

import API from 'utils/api';
import Logger from 'utils/logger';
import { useStore } from 'utils/hooks/store';

import { ActivityType } from 'utils/stores/Activities/constants';

import { VoiceMemoActivityProps } from './types';

const VoiceMemoActivity: React.FunctionComponent<VoiceMemoActivityProps> = ({ activity, ...props }) => {
  const { notification } = useStore();

  const handleDownload = async (): Promise<void> => {
    try {
      const {
        data: { recording },
      } = await API.loadVoiceMemoDetails(activity.uuid)();

      window.open(recording, '_blank');
    } catch (e) {
      Logger.error('Invalid load voice memo details API response', e);
      notification.enqueueErrorSnackbar('Voice Memo cannot be downloaded right now.');
    }
  };

  return (
    <File
      {...props}
      activity={{
        uuid: activity.uuid,
        file: activity.uuid,
        creator: activity.creator,
        type: ActivityType.VoiceMemo,
        size: activity.extra.fileSize,
        filename: activity.extra.fileName,
        created: activity.created as unknown as string,
      }}
      downloadFile={() => handleDownload}
    />
  );
};

export default observer(VoiceMemoActivity);
